import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {useLanguagesQuery} from "../../../../types.d";
import {ProgressAchievements} from "./ProgressAchievements";

export const LanguageOverview = (props: RouteComponentProps<{ language: string }>) => {
    const languages = useLanguagesQuery();

    if (!languages.data) {
        return null;
    }

    const language = languages.data.languages.filter(item => item.id === Number(props.match.params.language))[0];

    return <div>
        <h2 className={'mb-3'}>{ language.name }</h2>

        <ProgressAchievements baseUrl={props.match.url} languageId={language.id} />
    </div>
};
